export default __webpack_public_path__ + "static/media/topImg.f03e7009.png";